export default "__VITE_ASSET__a5407cb9__"